import { isFeatureEnabled } from 'common/featureFlags/featureFlags';
import { getOrCreateLDClient } from 'common/featureFlags/launchDarkly';

export const getDALTaskSystemEndpoint = (): string => process.env.REACT_APP_TASK_SYSTEM_ENDPOINT ?? '';

export const isDALAvailable = (): boolean => getDALTaskSystemEndpoint() !== '';

/**
 * Awaits LaunchDarkly initialization before reading, so a first visit — where nothing is cached —
 * gets the real value rather than the fallback. Resolves immediately once the client is up, which
 * is the normal case by the time any of these call sites run. React callers use `useDALEnabled`.
 *
 * The availability check stays so a build with no endpoint cannot be switched on into an empty URL.
 */
export const isDALEnabledAsync = async (): Promise<boolean> => {
    if (!isDALAvailable()) {
        return false;
    }

    await getOrCreateLDClient();

    return isFeatureEnabled('use_task_system');
};
